import dayjs from 'dayjs';
/** Shared id for the Custom preset — used by DateRangeFilter controlled-mode checks. */
export const CUSTOM_DATE_RANGE_PRESET_ID = 'custom';
function startOfDay(date) {
    return date.startOf('day').toDate();
}
function endOfDay(date) {
    return date.endOf('day').toDate();
}
function thisWeekRange(now = dayjs()) {
    const day = now.day();
    const offsetToMonday = day === 0 ? -6 : 1 - day;
    const start = now.add(offsetToMonday, 'day').startOf('day');
    const end = start.add(6, 'day').endOf('day');
    return { start: start.toDate(), end: end.toDate() };
}
export const DEFAULT_PRESETS = [
    {
        id: 'today',
        label: 'Today',
        compute: () => {
            const now = dayjs();
            return { start: startOfDay(now), end: endOfDay(now) };
        }
    },
    {
        id: 'yesterday',
        label: 'Yesterday',
        compute: () => {
            const yesterday = dayjs().subtract(1, 'day');
            return { start: startOfDay(yesterday), end: endOfDay(yesterday) };
        }
    },
    {
        id: 'this-week',
        label: 'This Week',
        compute: () => thisWeekRange()
    },
    {
        id: 'last-7-days',
        label: 'Last 7 Days',
        compute: () => {
            const end = dayjs();
            return { start: startOfDay(end.subtract(6, 'day')), end: endOfDay(end) };
        }
    },
    {
        id: 'this-month',
        label: 'This Month',
        compute: () => {
            const now = dayjs();
            return { start: now.startOf('month').toDate(), end: now.endOf('month').toDate() };
        }
    },
    {
        id: 'last-month',
        label: 'Last Month',
        compute: () => {
            const lastMonth = dayjs().subtract(1, 'month');
            return { start: lastMonth.startOf('month').toDate(), end: lastMonth.endOf('month').toDate() };
        }
    },
    {
        id: 'this-year',
        label: 'This Year',
        compute: () => {
            const now = dayjs();
            return { start: now.startOf('year').toDate(), end: now.endOf('year').toDate() };
        }
    },
    {
        id: CUSTOM_DATE_RANGE_PRESET_ID,
        label: 'Custom',
        compute: () => ({ start: null, end: null })
    }
];
